import Marquee from "react-fast-marquee";
import { MapPin, Car, AlertTriangle, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./FloatingButtons";
import { waLink } from "@/data/content";

const MARQUEE_ITEMS = [
  "Guincho 24 Horas",
  "Chegada Ágil",
  "Automóveis & Motos",
  "Socorro Imediato",
  "Zona Leste SP",
  "Preço Justo",
];

export const ConversionBanner = () => {
  return (
    <section data-testid="conversion-banner" className="bg-[#D50000] text-white">
      {/* Marquee strip */}
      <div className="border-b border-white/20 py-3">
        <Marquee speed={45} gradient={false}>
          {MARQUEE_ITEMS.concat(MARQUEE_ITEMS).map((t, i) => (
            <span
              key={i}
              className="mx-6 font-display text-lg font-semibold uppercase tracking-wide"
            >
              {t} <span className="mx-4 text-white/50">✦</span>
            </span>
          ))}
        </Marquee>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <Reveal>
            <h2 className="font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-5xl">
              Precisa de um<br />Guincho Agora?
            </h2>
            <p className="mt-4 max-w-md text-base text-white/85">
              Nossa equipe responde imediatamente pelo WhatsApp. Envie apenas
              estas 3 informações:
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="flex flex-col gap-4">
              {[
                { icon: MapPin, label: "Sua localização" },
                { icon: Car, label: "Modelo do veículo" },
                { icon: AlertTriangle, label: "Qual o problema" },
              ].map(({ icon: Icon, label }) => (
                <div
                  key={label}
                  className="flex items-center gap-4 border border-white/25 bg-black/10 px-5 py-4"
                >
                  <Icon size={22} className="shrink-0" />
                  <span className="text-base font-semibold uppercase tracking-wide">
                    {label}
                  </span>
                </div>
              ))}
              <a
                data-testid="banner-cta-btn"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-2 flex items-center justify-center gap-3 bg-[#111111] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:bg-black"
              >
                <WhatsAppIcon size={20} />
                Solicitar Atendimento
                <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
